var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pagination-container flex flex-wrap items-center" },
    [
      _c(
        "ul",
        { staticClass: "pagination row" },
        [
          _vm._l(_vm.pages, function (page, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "col-xs-2 col-sm-1",
                class: { active: page == _vm.pagination.current_page },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "pagination-link",
                    on: {
                      click: function ($event) {
                        return _vm.handleSelectPageCallback(page)
                      },
                    },
                  },
                  [_vm._v(_vm._s(page))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _vm.pagination.prev_page_url
            ? _c("li", { staticClass: "col-xs-2 col-sm-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "pagination-link",
                    attrs: { "aria-label": "Previous" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSelectPageCallback(
                          _vm.pagination.current_page - 1
                        )
                      },
                    },
                  },
                  [_vm._v("\n        Prev\n      ")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pagination.next_page_url
            ? _c("li", { staticClass: "col-xs-2 col-sm-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "pagination-link",
                    attrs: { "aria-label": "Next" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSelectPageCallback(
                          _vm.pagination.current_page + 1
                        )
                      },
                    },
                  },
                  [_vm._v("\n        Next\n      ")]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }